<p-button
  userCta
  [loading]="waitingForWishlistResponse"
  styleClass="p-button-rounded"
  [pTooltip]="wishlistHint"
  [tooltipOptions]="hintOptions"
  [ngClass]="{ active: isMovieInMyWishList(movie) }"
  (authorizedClick)="onAddMovieToWishlist()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="bookmarkIcon" [size]="'lg'"></fa-icon>
  </ng-template>
</p-button>
<p-button
  userCta
  [loading]="waitingForWatchedMovieResponse"
  [pTooltip]="watchedHint"
  [tooltipOptions]="hintOptions"
  styleClass="p-button-rounded"
  [ngClass]="{ active: movie.inMyWatched }"
  (authorizedClick)="onMarkMovieAsWatched()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="watchedIcon" [size]="'lg'"></fa-icon>
  </ng-template>
</p-button>
<p-button
  *ngIf="ratingEnabled"
  userCta
  [pTooltip]="rateHint"
  [tooltipOptions]="hintOptions"
  styleClass="p-button-rounded"
  [ngClass]="{ active: movie.myRank }"
  (authorizedClick)="onRateMovie()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="hearthIcon" [size]="'lg'"></fa-icon>
  </ng-template>
</p-button>
<p-button
  userCta
  styleClass="p-button-rounded"
  [pTooltip]="addToListHint"
  [tooltipOptions]="hintOptions"
  (authorizedClick)="addMovieToList()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="listIcon" [size]="'lg'"></fa-icon>
  </ng-template>
</p-button>
<p-button
  icon="pi pi-share-alt"
  styleClass="p-button-rounded"
  [pTooltip]="shareHint"
  [tooltipOptions]="hintOptions"
  (onClick)="onSharing()"
>
</p-button>
<!-- removing authorizedClick for error with ssr comming back to it -->
